import { useQuery } from "react-query";
import { EMPLOYEES_MOCK } from "../../constants/employee";
import { Employee } from "../../types/employee";

export const useEmployees = (teamId) => {
  return useQuery<Employee[], Error>(
    ["employees.mock", teamId],
    () => EMPLOYEES_MOCK
  );
};